import React from "react";

const InputField = ({ name, label, sublabel, placeholder, value, onChange, inputType, error, height, inputStyle }) => {
  return (
    <div className="d-flex flex-column mb-3">
      <span className="text-black fs-normal mb-0">{label}</span>
      {sublabel && <span className="text-grey1 fs-sm">{sublabel}</span>}
      <input className="bg-grey2 border-0 outline-0 px-2 py-2 rounded fs-md text-black fw-medium" name={name} value={value} type={inputType || "text"} onChange={onChange} placeholder={placeholder ?? "Enter text..."} style={inputStyle} />
      <span className="text-danger fs-sm">{error || ""}</span>
    </div>
  );
};

export default InputField;
